

























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { VideoCreate, VideoEdit } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class EditVideoDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  private data: any = {}
  private show = false
  private isEdit = false
  
  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = data
    this.isEdit = isEdit
    // 加载绑定商品

    if (this.data.cover) {
      this.data.coverList = this.data.cover.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.coverList = []
    }
    if (this.data.resourceUrl) {
      this.data.resourceUrlList = this.data.resourceUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.resourceUrlList = []
    }
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    title: [this.requiredRule],
    cover: [this.requiredRule],
    resourceUrl: [this.requiredRule],
  }

  public async save() {

    this.data.cover = this.data.coverList.map((e: any) => e.url).join(',')
    if(this.data.resourceUrlList.length > 0){
      this.data.resourceUrl = this.data.resourceUrlList[0].url
      this.data.width = this.data.resourceUrlList[0].width
      this.data.height = this.data.resourceUrlList[0].height
    }
    // this.data.resourceUrl = this.data.resourceUrlList.map((e: any) => e.url).join(',')

    console.log(this.data )
    
    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        let result = {}
        if(this.isEdit){
          result = await VideoEdit(this.data)
        } else {
          result = await VideoCreate(this.data)
        }
        console.log(result)
        this.close()
      } else {
        return false
      }
    })
  }
}
